import dayjs from 'dayjs';

export function secondsToHoursAndMinutes(seconds: number): string {
  if (seconds < 0) {
    return '-' + secondsToHoursAndMinutes(seconds * -1);
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (hours === 0 && minutes === 0) return '0시간';

  return (
    (hours > 0 ? hours + '시간 ' : '') + (minutes > 0 ? minutes + '분' : '')
  );
}

export function secondsToHoursAndMinutesSimple(seconds: number): string {
  if (seconds < 0) {
    return '-' + secondsToHoursAndMinutesSimple(seconds * -1);
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (hours === 0 && minutes === 0) return '';

  return (
    String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
  );
}

export function printWorkStartDtOrWorkEndDt(date: string | undefined) {
  if (!date) return '없음';

  return dayjs(date).format('YYYY-MM-DD HH:mm');
}

export const LocationTypes = [
  { text: '사무실', value: 'INSIDE' },
  { text: '재택', value: 'HOME' },
  { text: '외근', value: 'OUTSIDE' },
] as const;
